import moment from 'moment/moment'
import store from '@/stores/'
import UNIQUE from '@/common/unique'

const langValue = function (val) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = val
  })
  return obj
}
export default {
  id: 'cert',
  name: 'cert',
  type: 'action',
  moduleName: 'editor_module_cert',
  dataSet: {
    mods: 'cert',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'cert',
        value: langValue('Certification')
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'background',
        'border'
      ]
    },
    action: {
      name: 'cert',
      isRequired: true,
      label: langValue('Self-Certification'),
      labelValue: 'Self-Certification',
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
